export const getZonedDate = (timeZone: string, base: Date): Date => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
    .formatToParts(base)
    .reduce<Record<string, string>>((acc, p) => {
      if (p.type !== 'literal') acc[p.type] = p.value
      return acc
    }, {})

  const yyyy = Number(parts.year)
  const mm = Number(parts.month) - 1
  const dd = Number(parts.day)
  const hh = Number(parts.hour)
  const mi = Number(parts.minute)
  const ss = Number(parts.second)

  return new Date(yyyy, mm, dd, hh, mi, ss)
}

const TZ_ALIASES: Record<string, string> = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Macao': 'Asia/Macau',
  'Asia/Thimbu': 'Asia/Thimphu',
  'Europe/Kiev': 'Europe/Kyiv',
  'Europe/Nicosia': 'Asia/Nicosia',
  'America/Buenos_Aires': 'America/Argentina/Buenos_Aires',
  'America/Cordoba': 'America/Argentina/Cordoba',
  'America/Catamarca': 'America/Argentina/Catamarca',
  'America/Jujuy': 'America/Argentina/Jujuy',
  'America/Mendoza': 'America/Argentina/Mendoza',
  'America/Godthab': 'America/Nuuk',
  'Africa/Asmera': 'Africa/Asmara',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'Pacific/Enderbury': 'Pacific/Kanton'
}

export function canonicalTz(tz: string): string {
  return TZ_ALIASES[tz] ?? tz
}

export function tzName(tz: string): string {
  if (!tz) return ''
  const canonical = canonicalTz(tz)
  const parts = canonical.split('/')
  const trailing = parts.length > 1 ? parts.slice(1) : parts
  return trailing.join(' - ').replaceAll('_', ' ')
}

export function formatTimeInZone(date: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date)
}

export function formatHHmm(date: Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date)
}
